import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";

import { Observable, tap } from "rxjs";

import { SkeletonModule } from "primeng/skeleton";

import { PvdsService } from "@features/settings/services/pvds.service";
import { ButtonComponent, SubPageComponent } from "@shared/components";
import { PilotDataResponse, RequestState } from "@shared/models";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-pvds",
  standalone: true,
  imports: [SubPageComponent, ButtonComponent, SkeletonModule, CommonModule],
  templateUrl: "./pvds.component.html",
  styleUrl: "./pvds.component.scss",
})
export class PvdsComponent implements OnInit {
  globalService = inject(GlobalService);
  pvdsService = inject(PvdsService);

  pvdValue$: Observable<RequestState<PilotDataResponse>> = {} as Observable<RequestState<PilotDataResponse>>;
  originalPvdValue: number = 0;
  newPvdValue: number = 0;

  hasChanges: boolean = false;

  ngOnInit(): void {
    this.getPvds();
  }

  private getPvds(): void {
    this.pvdValue$ = this.pvdsService.getPvds().pipe(
      tap((response) => {
        if (response.response) {
          this.originalPvdValue = response.response.availablePVDs;
        }
      })
    );
  }

  onKeyUp(event: any): void {
    this.newPvdValue = Number(event.target.value);
    this.checkForChanges();
  }

  checkForChanges(): void {
    if (this.originalPvdValue !== this.newPvdValue) {
      this.hasChanges = true;
    } else {
      this.hasChanges = false;
    }
  }

  savePvds(): void {
    this.pvdsService.savePvds(this.newPvdValue).subscribe((response) => {
      if (response.response) {
        this.originalPvdValue = this.newPvdValue;
        this.checkForChanges();
      }
    });
  }
}
